/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import type { ReactNode } from "react";
import { Spinner } from "./Spinner";

/** A button's label while its action runs: a spinner and what is happening ("Saving…"). */
export function BusyLabel({
  busy,
  busyText,
  children,
}: {
  busy: boolean;
  busyText: string;
  children: ReactNode;
}) {
  if (!busy) {
    return <>{children}</>;
  }
  return (
    <>
      <span aria-hidden="true" className="inline-flex">
        <Spinner size="xs" className="text-bg-base" />
      </span>
      {busyText}
    </>
  );
}
